export enum GroupNotifications {
  send = "1",
  notSend = "2"
}
